// extracted by mini-css-extract-plugin
module.exports = {"selects":"CurrentMedConditions_selects___Gxb6"};